<template>
  <aside class="sidebar" :class="{ collapsed: authStore.sidebarCollapsed }">
    <!-- Header con logo y toggle -->
    <div class="sidebar-header">
      <img
        v-show="!authStore.sidebarCollapsed"
        src="../../assets/srkLogoWhite.png"
        alt="SRK"
        class="sidebar-logo"
      />
      <button class="sidebar-toggle" @click="authStore.toggleSidebar" :title="authStore.sidebarCollapsed ? 'Expandir menú' : 'Colapsar menú'">
        <i class="bi" :class="authStore.sidebarCollapsed ? 'bi-list' : 'bi-chevron-left'"></i>
      </button>
    </div>

    <!-- Navegación -->
    <nav class="sidebar-nav">
      <a
        v-for="item in navItems"
        :key="item.route"
        class="sidebar-link"
        :class="{ active: isActive(item.route) }"
        @click="navigateTo(item.route)"
        :title="authStore.sidebarCollapsed ? item.label : ''"
      >
        <i :class="item.icon" class="sidebar-icon"></i>
        <span class="sidebar-label">{{ item.label }}</span>
      </a>
    </nav>

    <!-- Footer con logout -->
    <div class="sidebar-footer">
      <a class="sidebar-link" @click="desloguear" :title="authStore.sidebarCollapsed ? 'Salir' : ''">
        <i class="bi bi-box-arrow-right sidebar-icon"></i>
        <span class="sidebar-label">Salir</span>
      </a>
    </div>
  </aside>
</template>

<script setup>
import { signOut } from 'aws-amplify/auth'
import { useRouter, useRoute } from 'vue-router'
import { usePageTitle } from '../../composables/usePageTitle.js'
import { useCatalogStore } from '../../stores/catalog.js'
import { useTimesStore } from '../../stores/times.js'
import { useAuthStore } from '../../stores/auth.js'

const router = useRouter()
const route = useRoute()
const catalogStore = useCatalogStore()
const timesStore = useTimesStore()
const authStore = useAuthStore()

usePageTitle()

const navItems = [
  // { route: '/', label: 'Horas Diarias', icon: 'bi bi-folder' },
  { route: '/carga', label: 'Timesheet', icon: 'bi bi-stopwatch' },
  { route: '/dashboard', label: 'Resumen', icon: 'bi bi-grid-1x2' },
  { route: '/calendario', label: 'Calendario', icon: 'bi bi-calendar4-week' },
  // { route: '/resumen', label: 'Resumen', icon: 'bi bi-bar-chart' },
  // { route: '/semana', label: 'Semana', icon: 'bi bi-calendar-range' },
  // { route: '/config', label: 'Configuración', icon: 'bi bi-gear' },
]

function isActive(path) {
  if (path === '/') {
    return route.path === '/' || /^\/\d/.test(route.path)
  }
  if (path === '/carga') {
    return route.path === '/carga' || route.path.startsWith('/carga/')
  }
  return route.path === path
}

function navigateTo(path) {
  if (route.path !== path) {
    router.push(path)
  }
}

async function desloguear() {
  try {
    await signOut()
    catalogStore.clearAll()
    timesStore.clearAll()
    authStore.resetAuth()
    router.push('/auth')
  } catch (error) {
    console.error('Error al desloguear:', error)
  }
}
</script>

<style scoped>
.sidebar {
  width: var(--sidebar-width-expanded);
  height: 100svh;
  background: var(--sidebar-bg);
  display: flex;
  flex-direction: column;
  transition: var(--sidebar-transition);
  overflow: hidden;
  flex-shrink: 0;
}

.sidebar.collapsed {
  width: var(--sidebar-width-collapsed);
}

.sidebar-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.sidebar-logo {
  width: 90px;
  opacity: 1;
  transition: opacity 0.2s;
}

.sidebar-toggle {
  background: none;
  border: none;
  color: var(--sidebar-text);
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--sidebar-text-active);
}

.collapsed .sidebar-toggle {
  margin: 0 auto;
}

.sidebar-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 8px;
  gap: 2px;
}

.sidebar-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  color: var(--sidebar-text);
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
  font-size: var(--font-size-base);
}

.sidebar-link:hover {
  background: rgba(255, 255, 255, 0.08);
  color: var(--sidebar-text-active);
}

.sidebar-link.active {
  background: var(--sidebar-accent);
  color: #fff;
}

.sidebar-icon {
  font-size: 1.15rem;
  width: 24px;
  text-align: center;
  flex-shrink: 0;
}

.sidebar-label {
  opacity: 1;
  transition: opacity 0.15s;
  overflow: hidden;
}

.collapsed .sidebar-label {
  opacity: 0;
  width: 0;
}

.sidebar-footer {
  padding: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
</style>
